import { CharacteristicObject } from './characteristic/characteristic-object.model';

export class CharacteristicsObject {


  constructor(public inputCharacteristics: Array<CharacteristicObject>, public outputCharacteristics: Array<CharacteristicObject>) {
  }

  static create(): CharacteristicsObject {

    const inputChars: Array<CharacteristicObject> = new Array<CharacteristicObject>();
    const outputChars: Array<CharacteristicObject> = new Array<CharacteristicObject>();

    return new CharacteristicsObject(inputChars, outputChars);
  }

  public clone(): CharacteristicsObject {
    const inputs = this.inputCharacteristics.slice();
    const outputs = this.outputCharacteristics.slice();
    for (let i = 0; i < inputs.length; i++) {
      inputs[i] = inputs[i].clone();
    }
    for (let i = 0; i < outputs.length; i++) {
      outputs[i] = outputs[i].clone();
    }
    return new CharacteristicsObject(inputs, outputs);
  }

  public toString(): string {
    let inputs = '';
    for (let input of this.inputCharacteristics) {
      inputs = inputs.concat('{' + input.name + ': ' + input.value + '} ');
    }

    let outputs = '';
    for (let output of this.outputCharacteristics) {
      outputs = outputs.concat('{' + output.name + ': ' + output.value + '} ');
    }

    return inputs.concat(outputs).toString();
  }

  public length(): number {
    return this.inputCharacteristics.length + this.outputCharacteristics.length;
  }

  public getAllCharacteristics(): Array<CharacteristicObject> {
    return this.inputCharacteristics.concat(this.outputCharacteristics);
  }

}
